import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { WinnerHomepage } from 'utils/plasmicCMS';
import { EnterButton } from '../enter-button/EnterButton';
import { WinnerCarousel } from './WinnerCarousel';
import styles from './WinnerSection.module.css';

const WINNERS_SECTION_TITLE = 'Thousands of weekly winners';

export const WinnerSection = ({
  isSubscriber,
  winners,
}: {
  isSubscriber: boolean;
  winners: WinnerHomepage[];
}) => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div className={styles.container}>
          <h2
            data-text={WINNERS_SECTION_TITLE}
            className={`aboutUsTypographyHeaderXlargeOnWhite ${styles.textMaxWidth}`}
          >
            {WINNERS_SECTION_TITLE}
          </h2>
          <p className={`textAlignCenter noMargin`}>
            🎉 From free entries to epic holidays: over{' '}
            <strong>£12 million</strong> worth of prizes won 🎉
          </p>

          <WinnerCarousel winners={winners} />

          {!isSubscriber && <EnterButton />}
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
